<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>Recherche</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <div class="form-item">
                <mat-form-field>
                    <mat-label>Type d'élément à rechercher</mat-label>
                    <mat-select [formControl]="elementTypeControl" tabindex="1">
                        <mat-option [value]="WorkflowElementType.Trigger">Trigger</mat-option>
                        <mat-option [value]="WorkflowElementType.Action">Action</mat-option>
                        <mat-option [value]="WorkflowElementType.Step">Etape</mat-option>
                        <mat-option [value]="WorkflowElementType.Event">Evènement</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="form-item">
                <mat-form-field>
                    <mat-label>Id de l'élément à rechercher</mat-label>
                    <input matInput [formControl]="elementIdControl" type="text" autocomplete="off" tabindex="2" />
                </mat-form-field>
            </div>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="cancel()">Annuler</button>
        <button mat-raised-button class="accent-button" (click)="search()">Rechercher</button>
    </mat-card-actions>
</mat-card>
